import { PuxIcon, PuxSimcard, PuxSpinner, PuxText } from "@phonero/pux-react"
import { ApiProductState, SimCardType2 } from "@phonero/common-graphql/types"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import { formatTelephoneNumber } from "@phonero/pux-core"
import { editUnderline } from "@phonero/pux-icons/icons"
import css from "./ActiveSimCard.module.scss"
import { SimCardFragment } from "./AvailableAndActiveSimCards.generated"
import { getStateColour } from "../util/simCardHelpers"

export interface IActiveSimCard {
  card: SimCardFragment
  updateSimCardLoading: boolean
  subscriptionState: ApiProductState
  lastEditSimAliasId: string | undefined
  onEditSimAlias:
    | ((value: React.SetStateAction<SimCardFragment | undefined>) => void)
    | null
}

export const ActiveSimCard = ({
  card,
  updateSimCardLoading,
  lastEditSimAliasId,
  subscriptionState,
  onEditSimAlias,
}: IActiveSimCard) => {
  const { t } = useTranslation()
  const editable = card.type !== SimCardType2.Subscription && !!onEditSimAlias
  return (
    <PuxSimcard
      fill="solid"
      className={css.simCard}
      color={card.type === SimCardType2.Smartwatch ? "dark" : "light"}
      editableName={editable}
      eSim={card.embeddedSim}
      smartWatch={card.type === SimCardType2.Smartwatch}
      // Putting it here will make sure the component re-renders properly when simCardName changes
      type={!!card.simCardName ? t("SimCard.Type_" + card.type) : ""}
    >
      <PuxText slot="name" title={card.simCardName ?? ""}>
        {!!card.simCardName ? card.simCardName : t("SimCard.Type_" + card.type)}
      </PuxText>
      {editable && (
        <button
          slot="nameEditButton"
          className={classNames(
            css.editButton,
            updateSimCardLoading &&
              lastEditSimAliasId === card.id &&
              css.loading,
            "btn-reset"
          )}
          disabled={updateSimCardLoading}
          onClick={() => onEditSimAlias(card)}
        >
          <PuxIcon icon={editUnderline} size="extra-small" />
          <PuxSpinner color="dark" />
        </button>
      )}
      {!!card?.msisdn && (
        <PuxText slot="msisdn">
          {formatTelephoneNumber(card?.msisdn).formatted}
        </PuxText>
      )}
      <PuxText slot="pin1">{card.pin1}</PuxText>
      <PuxText slot="puk1">{card.puk1}</PuxText>
      <PuxText slot="number">
        {card.iccid?.substring(card.iccid.length - 12)}
      </PuxText>
      <PuxText
        slot="chip"
        color={getStateColour(card?.state)}
        style={{ fontStyle: "italic" }}
      >
        {subscriptionState === ApiProductState.Ordered
          ? "Aktiveres"
          : t("ProductState." + card.state)}
      </PuxText>
    </PuxSimcard>
  )
}
